import 'ui-core/plugins/stickyElements/js/stickyElements';
(function (UX) {
    UX.stickyElements.selectors['header'] = 'div.base';
    UX.stickyElements.dynamicHeaderHeight = true;
})(UX);
